function getCategoryRoute(productType = '', page) {
    var ref;
    const productRoutes = (ref = page === null || page === void 0 ? void 0 : page.getComponent()) === null || ref === void 0 ? void 0 : ref.getModels().productRoutes;
    if (!productRoutes) {
        return undefined;
    }
    const key1 = Object.keys(productRoutes).find((key)=>key === productType && productRoutes
    );
    return key1 && productRoutes[key1];
}

export { getCategoryRoute };
//# sourceMappingURL=get-category-route.js.map
